import * as Yup from 'yup';

export const LoginValidationSchema = () => {
    return Yup.object({
        email: Yup.string().email("Email inválido").max(255).required("Email obrigatório"),
        password: Yup.string().max(255).required("Password é obrigatória")
    })
}